(function () {
  function initFaq(root) {
    if (!root || root.dataset.nlcFaqInit) return;
    root.dataset.nlcFaqInit = 'true';

    var topicCards = Array.prototype.slice.call(root.querySelectorAll('.nlc-faq-topic-card'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('.nlc-faq-group'));
    var currentCategoryLabel = root.querySelector('.nlc-faq-current-category');
    var expandAllBtn = root.querySelector('.nlc-faq-expand-all');
    var searchInput = root.querySelector('.nlc-faq-search-input');
    var resultsCount = root.querySelector('.nlc-faq-results-count');
    var listWrap = root.querySelector('.nlc-faq-list-wrap');
    var topicsSection = root.querySelector('.nlc-faq-topics');
    var allItems = Array.prototype.slice.call(root.querySelectorAll('.nlc-faq-item'));

    function setActiveCard(key) {
      topicCards.forEach(function (card) {
        var isActive = card.getAttribute('data-category') === key;
        card.dataset.active = isActive ? 'true' : 'false';
        card.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function showCategory(key, opts) {
      opts = opts || {};
      if (searchInput) searchInput.value = '';
      if (resultsCount) resultsCount.textContent = '';

      groups.forEach(function (group) {
        var match = group.getAttribute('data-category-group') === key;
        group.hidden = !match;
      });

      allItems.forEach(function (item) {
        item.hidden = false;
        var label = item.querySelector('.nlc-faq-item-category-label');
        if (label) label.hidden = true;
      });

      setActiveCard(key);

      var card = topicCards.filter(function (c) {
        return c.getAttribute('data-category') === key;
      })[0];
      if (currentCategoryLabel && card) {
        currentCategoryLabel.textContent = card.querySelector('.nlc-faq-topic-title').textContent;
      }

      if (opts.scroll && listWrap) {
        var top = listWrap.getBoundingClientRect().top + window.pageYOffset - 24;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    }

    function closeAllItems() {
      allItems.forEach(function (item) {
        item.classList.remove('is-open');
        var q = item.querySelector('.nlc-faq-item-question');
        if (q) q.setAttribute('aria-expanded', 'false');
      });
      if (expandAllBtn) expandAllBtn.textContent = expandAllBtn.dataset.expandLabel || 'Expand all +';
      if (expandAllBtn) expandAllBtn.dataset.state = 'collapsed';
    }

    topicCards.forEach(function (card) {
      card.addEventListener('click', function () {
        var key = card.getAttribute('data-category');
        closeAllItems();
        showCategory(key, { scroll: true });
      });
    });

    allItems.forEach(function (item) {
      var q = item.querySelector('.nlc-faq-item-question');
      if (!q) return;
      q.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        item.classList.toggle('is-open', !isOpen);
        q.setAttribute('aria-expanded', String(!isOpen));
      });
    });

    if (expandAllBtn) {
      expandAllBtn.dataset.expandLabel = expandAllBtn.textContent;
      expandAllBtn.dataset.state = 'collapsed';
      expandAllBtn.addEventListener('click', function () {
        var visibleItems = allItems.filter(function (item) {
          return !item.hidden && item.offsetParent !== null;
        });
        var shouldExpand = expandAllBtn.dataset.state === 'collapsed';
        visibleItems.forEach(function (item) {
          item.classList.toggle('is-open', shouldExpand);
          var q = item.querySelector('.nlc-faq-item-question');
          if (q) q.setAttribute('aria-expanded', String(shouldExpand));
        });
        expandAllBtn.dataset.state = shouldExpand ? 'expanded' : 'collapsed';
        expandAllBtn.textContent = shouldExpand ? 'Collapse all −' : (expandAllBtn.dataset.expandLabel || 'Expand all +');
      });
    }

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        var term = searchInput.value.trim().toLowerCase();

        if (!term) {
          var activeCard = topicCards.filter(function (c) {
            return c.dataset.active === 'true';
          })[0] || topicCards[0];
          if (activeCard) showCategory(activeCard.getAttribute('data-category'));
          if (resultsCount) resultsCount.textContent = '';
          if (topicsSection) topicsSection.style.display = '';
          if (currentCategoryLabel) currentCategoryLabel.hidden = false;
          return;
        }

        var matchCount = 0;

        groups.forEach(function (group) {
          group.hidden = false;
        });

        allItems.forEach(function (item) {
          var questionText = (item.getAttribute('data-question') || '').toLowerCase();
          var answerText = (item.getAttribute('data-answer') || '').toLowerCase();
          var matches = questionText.indexOf(term) !== -1 || answerText.indexOf(term) !== -1;
          item.hidden = !matches;
          var label = item.querySelector('.nlc-faq-item-category-label');
          if (label) label.hidden = !matches;
          if (matches) matchCount++;
        });

        setActiveCard('');
        if (topicsSection) topicsSection.style.display = 'none';
        if (currentCategoryLabel) currentCategoryLabel.hidden = true;
        if (resultsCount) {
          resultsCount.textContent = matchCount === 0
            ? 'No questions found for "' + searchInput.value.trim() + '".'
            : matchCount + ' question' + (matchCount === 1 ? '' : 's') + ' found for "' + searchInput.value.trim() + '".';
        }
      });
    }

    if (topicCards.length) {
      showCategory(topicCards[0].getAttribute('data-category'));
    }
  }

  function initAll() {
    document.querySelectorAll('.nlc-faq').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector ? e.target.querySelector('.nlc-faq') : null;
    if (root) {
      root.dataset.nlcFaqInit = '';
      initFaq(root);
    }
  });
})();
